var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dui-review-rating",class:{ 'video-review': _vm.videoReview }},[_c('DuiRating',{class:_vm.ratingClass,attrs:{"value":_vm.rating}}),_vm._v(" "),(_vm.videoReview)?_c('DuiIconVideo',{staticClass:"video-icon icon-yellow icon-xl",attrs:{"title":"Video review"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }